<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      class="scaling-svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <g data-name="Group 57" transform="translate(-1772 -291)">
        <g transform="translate(1772 291)">
          <g data-name="Icon_blank_empty" transform="translate(3 1.5)">
            <path
              d="M10.5,15h-9A1.5,1.5,0,0,1,0,13.5V1.5A1.5,1.5,0,0,1,1.5,0H9l3,3V13.5A1.5,1.5,0,0,1,10.5,15ZM2.25,1.5a.751.751,0,0,0-.75.75v10.5a.751.751,0,0,0,.75.75h7.5a.751.751,0,0,0,.751-.75V4.5h-3v-3ZM9,1.5V3h1.5Z"
            />
          </g>
        </g>
        <path
          data-name="Path 12"
          d="M4.833,0,2.268-2.907V0H.576V-6.408H2.268v2.754L4.761-6.408h1.98L3.906-3.366,6.84,0Z"
          transform="translate(1778 304)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CorrectIcon extends Vue {}
</script>

<style>
</style>
